import { setArray } from "../reducers/array/actions";
import {
	setSorted,
	setComparing,
	setSwapping,
	setSignificant,
} from "../reducers/element-types/actions";
import { setRunStatus } from "../reducers/run-status/actions";

function heapSort(array, dispatch, speed) {
	console.log("heap");
}

export default heapSort;
